import React from 'react';
import {Switch} from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import IncidentReport from './incident-report';
import IncidentReportDetail from './incident-report-detail';
import IncidentReportUpdate from './incident-report-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={IncidentReportUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={IncidentReportUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={IncidentReportDetail} />
      <ErrorBoundaryRoute path={match.url} component={IncidentReport} />
    </Switch>
  </>
);

export default Routes;
